module.exports = __webpack_public_path__ + "static/media/punch2.4b4f4fb1.mp3";